export const DIALOG_PANEL_CLASS: string = 'mp-dialog-panel';
